import component from './details/components/details';

export default {
  component
};
